import { findExtendedObjectById } from '@bpd-library/utilities';
import { useAreaData } from '@utilities/hooks';

export async function triggerSearchObjectByID({ key, target }: KeyboardEvent) {
    const data = await useAreaData();

    if (key == 'Enter') {
        const objectById = findExtendedObjectById(data, (target as HTMLInputElement).value);

        if (objectById) {
            console.log(objectById);
            return;
        }

        console.log('The ID doesnt exist on Public API');
    }
}
